@if (isLoading) {
  <suvo-core-loading-spinner />
} @else {
  <div class="bi-margin d-flex fd-col ai-stretch gap-16">
    <div class="flex-1 d-flex ai-stretch">
      @if (view && item && definition) {
        <suvo-bi-smart-grid
          class="flex-1"
          style="max-width: 100%"
          [settings]="gridSettings"
          [grid]="view"
          [editMode]="editGridMode"
          [saveChangesAsync]="onSaveGrid"
        >
          <ng-template let-tileDefinition>
            <suvo-bi-view-tile-wrapper
              [viewTile]="tileDefinition"
              [item]="item"
              [form]="dataForm"
              [definition]="definition"
              [editItemMode]="editItemMode"
            />
          </ng-template>
        </suvo-bi-smart-grid>
      } @else {
        <div class="error-container">
          <suvo-core-error-message
            title="No data"
            message="Data is missing or there was a problem loading data. You may need to upgrade your subscription to view this item."
          />
        </div>
      }
    </div>
  </div>
}
